module.exports = __webpack_public_path__ + "static/child-portrait-3-4-7f46957a54ea7a7f51773c1da43a6c03.jpg";